import styled from 'styled-components';

export const CustomerFooterWrapper = styled.div`
  padding: 40px 20px;
  .title {
    font-weight: 500;
    font-size: 1.2rem;
  }

  .btnGroup {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    button {
      width: 100%;
      height: 40px;
      background-color: #fff;
      border-radius: 4px;
      font-weight: 700;
      font-size: 1.2rem;
      text-align: center;
      border: 1px solid #dcdce4;

      &.btnKaKao {
        background-color: #f6e24b;
        border-color: #dbc500;
        img {
          width: 20px;
          vertical-align: bottom;
        }
      }
    }
  }

  ul {
    margin-top: 16px;
    li {
      list-style: none;
      margin-left: 0;
      font-size: 1.2rem;
      line-height: 2.2rem;
      color: #555;
      i {
        text-decoration: underline;
        font-weight: 700;
      }
    }
  }
`;
